import themes from './themes'

const DEFAULT_THEME_NAME = 'light'

/**
 * @param {unknown} name
 * @returns {'light' | 'dark'}
 */
export function resolveThemeName (name) {
  if (typeof name !== 'string') {
    return DEFAULT_THEME_NAME
  }

  const normalized = name.trim().toLowerCase()
  if (normalized in themes) {
    return normalized
  }

  return DEFAULT_THEME_NAME
}

export default resolveThemeName
